var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclePlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#FF6633"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.522 10.4077C15.522 9.86694 15.9604 9.42859 16.5011 9.42859C17.0418 9.42859 17.4802 9.86694 17.4802 10.4077V15.5209H22.5935C23.1342 15.5209 23.5725 15.9593 23.5725 16.5C23.5725 17.0407 23.1342 17.4791 22.5935 17.4791H17.4802V22.5924C17.4802 23.1331 17.0418 23.5714 16.5011 23.5714C15.9604 23.5714 15.522 23.1331 15.522 22.5924V17.4791H10.4088C9.86804 17.4791 9.42969 17.0407 9.42969 16.5C9.42969 15.9593 9.86804 15.5209 10.4088 15.5209H15.522V10.4077Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlusIcon);
export default __webpack_public_path__ + "static/media/circle-plus-icon.3d7e1145add02d752d18e3bb42e00db6.svg";
export { ForwardRef as ReactComponent };